module.exports = __webpack_public_path__ + "static/media/mesotherapy.e50ddead.svg";